var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.25C7.5 17.625 8.625 18.75 10 18.75C11.375 18.75 12.5 17.625 12.5 16.25",
    stroke: "currentColor",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.375C10.6904 4.375 11.25 3.81536 11.25 3.125C11.25 2.43464 10.6904 1.875 10 1.875C9.30964 1.875 8.75 2.43464 8.75 3.125C8.75 3.81536 9.30964 4.375 10 4.375Z",
    stroke: "currentColor",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.875C7.84518 11.875 8.125 11.5952 8.125 11.25C8.125 10.9048 7.84518 10.625 7.5 10.625C7.15482 10.625 6.875 10.9048 6.875 11.25C6.875 11.5952 7.15482 11.875 7.5 11.875Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.875C8.75 6.875 7.5 7.9375 7.5 9.375",
    stroke: "currentColor",
    strokeWidth: 1.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.25C15 12.3125 15.8125 13.125 16.875 13.125V15.625H3.125V13.125C4.1875 13.125 5 12.3125 5 11.25V9.375C5 6.625 7.25 4.375 10 4.375C12.75 4.375 15 6.625 15 9.375V11.25Z",
    stroke: "currentColor",
    strokeWidth: 1.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell20);
export default __webpack_public_path__ + "static/media/Bell-20.8712a7d3.svg";
export { ForwardRef as ReactComponent };